import { createStore, applyMiddleware, compose } from 'redux'
import { browserHistory } from 'react-router'
import thunkMiddleware from 'redux-thunk'

import { reducer } from './modules'
import { middleware as analyticsMiddleware } from './analytics'
import { routerMiddleware } from 'react-router-redux'
import { isStage, isDev } from 'client/lib/deploy_env'

const getComposeEnhancers = () => {
  const isUsingDevTools =
    (isDev() || isStage()) &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  if (isUsingDevTools) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
  }
  return compose
}
const composeEnhancers = getComposeEnhancers()

const middleware = [
  routerMiddleware(browserHistory),
  thunkMiddleware,
  analyticsMiddleware,
]

export function configureStore(initialState, callback) {
  const store = createStore(
    reducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  )
  callback(store)
}
